import React from "react";

const SeuilRentabilite = () => {
  return (
    <div className="seuil-rentabilite">
      <h2>Seuil de rentabilité</h2>
      <p>Analyse du seuil de rentabilité.</p>
    </div>
  );
};

export default SeuilRentabilite;
